<template>
  <div class="row" style="height: 90vh; overflow: auto">
    <el-dialog title="Esqueci a Senha" :visible.sync="forgotPassword">
      <el-form
        ref="teste"
        :model="forgot"
        :rules="rules"
        label-position="top"
        label-width="auto"
      >
        <el-form-item label="E-mail" prop="mail">
          <el-input
            type="email"
            v-model="forgot.mail"
            placeholder="E-mail de recuperação"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="forgotPassword = false">Cancelar</el-button>
        <el-button
          type="primary"
          @click="forgotMyPassword()"
          :loading="loading"
        >
          {{ loading ? "Enviando ..." : "Enviar Senha de recuperação" }}
          <i class="el-icon-message"></i>
        </el-button>
      </span>
    </el-dialog>

    <div class="col-lg-4 bg-login d-none d-lg-block" id="bg-login"></div>
    <div class="col-lg-8 col-md-12 align-self-center">
      <div class="row justify-content-center">
        <div class="login col-lg-6 col-md-8 col-sm-12">
          <div class="logo">
            <img :src="srcLogoImage" alt="logo" width="200" />
          </div>

          <div class="portal">
            <h1>Portal do Fornecedor</h1>
          </div>

          <form class="user mt-4" id="signin" @submit.prevent="signin()">
            <div class="form-row">
              <div class="form-group col-lg-12">
                <label>Usuário</label>
                <input
                  type="email"
                  pattern="^[^\s].+[^\s]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  v-model="email"
                  class="form-control"
                  placeholder="E-mail"
                  required
                  :disabled="loading"
                />
                <div class="invalid-feedback">Campo obrigatório</div>
              </div>
              <div class="form-group col-lg-12">
                <label>Senha</label>

                <input
                  type="password"
                  v-model="password"
                  class="form-control"
                  placeholder="Senha"
                  required
                  :disabled="loading"
                />
                <div class="invalid-feedback">Campo obrigatório</div>
              </div>
              <div class="form-group col-lg-12">
                <div class="custom-control custom-checkbox small">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="customCheck"
                  />
                  <label class="custom-control-label" for="customCheck"
                    >Lembre-Me</label
                  >
                </div>
              </div>
              <button
                type="submit"
                class="btn-lg el-button el-button--primary btn-block mb-2 mt-5"
              >
                Entrar
              </button>
            </div>
          </form>
          <hr class="mt-5 bg-secondary" />
          <div class="text-center col-lg-12 mt-2">
            <button
              class="btn btn-link text-gray-600"
              @click="forgotPassword = true"
            >
              Esqueceu sua senha?
            </button>
          </div>
        </div>
      </div>
    </div>

    <footer>
      <cookie-law theme="dark-lime"></cookie-law>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { UserService } from "@/services/users/user.services";
import CookieLaw from "vue-cookie-law";
// import router from "../routes";

export default {
  name: "login",
  components: {
    CookieLaw
  },
  computed: {
    ...mapGetters("auth", [
      "authenticating",
      "authenticationError",
      "authenticationErrorCode"
    ])
  },
  data() {
    return {
      srcLogoImage: "../assets/logo_gradient.png",
      forgotPassword: false,
      forgot: {
        mail: ""
      },
      email: "",
      password: "",
      loading: false,
      rules: {
        mail: [
          {
            required: true,
            pattern: "^[a-z0-9.]+@[a-z0-9]+\.[a-z]+\.([a-z]+)?$",
            message: "Informe um e-mail valido!",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {},
  updated() {},
  mounted() {
    const vm = this;
    let prefix = "";
    if (vm.$route.params.prefix && vm.$route.params.prefix === "tembici")
      prefix = vm.$route.params.prefix + "_";
    vm.srcLogoImage = `../assets/${prefix}logo_gradient.png`;
    const bgLogin = document.getElementById("bg-login");
    bgLogin.style.backgroundImage = `url('../assets/${prefix}bg-login.jpg')`;
    bgLogin.style.backgroundSize = "cover";
    bgLogin.style.backgroundPosition = "center";
  },
  methods: {
    forgotMyPassword: function() {
      const vm = this;
      this.$refs.teste.validate(valid => {
        if (valid) {
          vm.loading = true;
          UserService.forgotPassword(vm.forgot.mail)
            .then(response => {
              this.$message({
                type: "success",
                message: `Foi enviado uma nova senha para o email: ${response}`
              });
            })
            .catch(error => {
              this.$message({
                type: "error",
                message: error
              });
            })
            .finally(() => (vm.loading = false));
        } else {
          this.$message({
            type: "error",
            message: "Forneça um e-mail valido para continuar."
          });
        }
      });
    },
    ...mapActions("auth", ["login"]),
    ...mapGetters("auth", ["getPrefixRoute"]),
    signin: function() {
      const vm = this;
      vm.notauthorization = false;
      const loading = vm.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.login({
        email: this.email,
        password: this.password
      })
        .catch(error =>
          this.$message({ type: "error", message: error.message })
        )
        .then(response => {
          vm.$router
            .push({ name: "home", params: { prefix: vm.getPrefixRoute() } })
            .catch(error => console.info(error.message));
        })
        .finally(() => loading.close());
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  padding: 40px;

  input {
    height: 60px;
  }

  .logo {
    text-align: center;
  }
}

.portal h1 {
  color: #42677c;
  font-size: 2rem;
  margin-top: 1em;
  margin-bottom: 1em;
  text-align: center;
}

.sticky-footer {
  border-top: 1px solid #b56969;
  bottom: 0;
  position: absolute;
  width: 100%;
}
.bg-login {
  background: url("../assets/bg-login.jpg");
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-position: center;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: -2;
    opacity: 0.3;
    background: linear-gradient(to right, #23074d, #cc5333);
  }
}
.btn-lg {
  color: #fff !important;
}
</style>
